import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { KEY_CODE } from '@commoncore/services/universal.service';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-folder-name-not-supported-for-upload',
  templateUrl: './folder-name-not-supported-for-upload.component.html',
  styleUrls: ['./folder-name-not-supported-for-upload.component.scss'],
  imports:[DependenciesModule]
})
export class FolderNameNotSupportedForUploadComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.renameFolder(false);
    }else if (event.key === "Enter" && this.selectedOption == "rename" && this.enableButton){
      this.renameFolder(true);
    }else if (event.key === "Enter" && this.selectedOption == "cancel"){
      this.renameFolder(false);
    }

    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      $('#btn-rename-folder-cancel').addClass('no-bg');
      $('#btn-rename-folder-rename').removeClass('no-bg');
      this.selectedOption = "rename"
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      $('#btn-rename-folder-cancel').removeClass('no-bg');
      $('#btn-rename-folder-rename').addClass('no-bg');
      this.selectedOption = "cancel"
    }
  }
  @Input() currentFolder:any;
  @Input() enableButton:boolean;
  @Input() showFolderNotSupportedPopUp:boolean;
  @Output() renamedFolder = new EventEmitter();
  @Output() createFolderValidation = new EventEmitter();
  public unsupportedChars:string = "/ \\ < > : \" | ? *";
  renameError:any = {"msg":"",type:"default"};
  universalService:any;
  selectedOption:string = "rename";
  oldFolderName:string = "";
  newName:string= "";
  

  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService);
   }

  ngOnInit(): void {
    this.oldFolderName = this.currentFolder["name"];
    setTimeout(() => {
      $('#btn-rename-folder-rename').removeClass('no-bg');
      $('#btn-rename-folder-cancel').addClass('no-bg');
    }, 10);
    var regex = new RegExp(/[/\/\\/<>:"|?*]/, 'g')
    this.currentFolder["name"] = this.currentFolder?.["name"].replace(regex,'_');
    this.newName = this.currentFolder["name"];
    this.newNameValidation(this.newName);
    this.universalService.errorMessage = "";
  }


  renameFolder(type){
    if(type){
      this.newName = this.newName.trim();
      this.currentFolder["name"] = this.newName;
      this.currentFolder["newName"] = this.newName;
      if(this.currentFolder["uploadFromButtonClick"]){
        this.updateFolderNameInTheFolderHeirarchy();
      }
      this.renamedFolder.emit(this.currentFolder);
    }else{
      this.renamedFolder.emit(false);
    }
    
  }
  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();

  }

  newNameValidation(name){
    this.newName = name;
    console.log("name of edited folder ",name)
    this.createFolderValidation.emit(name)
  }

  updateFolderNameInTheFolderHeirarchy(){
    const indexes = this.currentFolder["subfolders"]
      .map((element, index) => {
        if (element.parentUniqueKey == "0") {
          return index;
        }
      })
      .filter(element => element >= 0);
      indexes.map(index=>{
        if(index == 0){
          this.currentFolder["subfolders"][0]["folder"] = this.newName
        }else{
          this.currentFolder["subfolders"][index]["parent"] = this.newName
        }
      })
    console.log("result of indexes==>",indexes,this.currentFolder);
  }
  

}
